import { IModel, Model, ModelRecord } from '@common/models';
import { DateTime } from 'luxon';
import { makeObservable, observable } from 'mobx';
export interface IPetDiagnosisStatusHistoryModel extends IModel {
  petDiagnosisStatusHistoryId: number;
  petDiagnosisId: number;
  diagnosisStatusId: number;
  notes: string | null;
  changedByUserName: string;
  dateUpdated: string;
  totalHistoryCount: number;
  veterinarianId?: number| null;
  storeId?: number | null;
}

export class PetDiagnosisStatusHistoryModel
  extends Model
  implements ModelRecord<IPetDiagnosisStatusHistoryModel>
{
  @observable petDiagnosisStatusHistoryId: number;
  @observable petDiagnosisId: number;
  @observable diagnosisStatusId: number;
  @observable notes: string | null;
  @observable changedByUserName: string;
  @observable dateUpdated: DateTime;
  @observable totalHistoryCount: number;
  @observable veterinarianId: number | null;
  @observable storeId: number | null;
  constructor(params: IPetDiagnosisStatusHistoryModel) {
    super(params);
    this.petDiagnosisStatusHistoryId = _.defaultTo(
      params.petDiagnosisStatusHistoryId,
      0,
    );
    this.petDiagnosisId = _.defaultTo(params.petDiagnosisId, 0);
    this.diagnosisStatusId = _.defaultTo(params.diagnosisStatusId, 0);
    this.notes = _.defaultTo(params?.notes, '');
    this.changedByUserName = _.defaultTo(params.changedByUserName, '');
    this.dateUpdated = DateTime.fromISO(params.dateUpdated, { zone: 'utc' });
    this.totalHistoryCount = _.defaultTo(params.totalHistoryCount, 1);    
    this.veterinarianId = _.defaultTo(params.veterinarianId, null);
    this.storeId = _.defaultTo(params.storeId, null);
    makeObservable(this);
  }
}
